import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomerStatsOptions } from 'src/app/enums/customer-stats-options.enum';
import { SortByOptions } from 'src/app/models/customer.model';
import { NewServiceStats } from 'src/app/models/new-service-stats.model';
import { SiteVerificationsStats } from 'src/app/models/siteVerification.model';
import { CustomerService } from 'src/app/services/customer.service';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { SiteVerificationService } from 'src/app/services/siteVerification.service';
import { PermissionsService } from 'shared-lib';
@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.scss']
})
export class NewServiceComponent implements OnInit {

  constructor(private siteVerificationService: SiteVerificationService,
    private toastr: ToastrService,
    private customerService: CustomerService,
    private kycAccountService: AccountKycService,
    private router: Router,
    private route: ActivatedRoute,
    public permissionsService: PermissionsService) {
    this.utilityId = parseInt(localStorage.getItem('utilityId') || '', 10);
    this.currentTab = parseInt(this.route.snapshot.paramMap.get('id') || '1', 10);
  }

  currentTab: number;
  serviceOrderStats: SiteVerificationsStats;
  customerStats: NewServiceStats;
  serviceConnectionChargesCount: number = 0;
  serviceRequestTrackerCount: number = 0;
  utilityId: number;
  id: number;

  ngOnInit(): void {
    const firstAllowedTab = this.getFirstAllowedTab();
    if (firstAllowedTab == null) {
      this.toastr.error('You do not have permission to view any tabs on New Service Page.');
      this.router.navigate(['/']);
      return;
    }
    this.id = parseInt(this.route.snapshot.paramMap.get('id') || '1', 10);
    this.changeTab(this.isTabAllowed(this.id) ? this.id : firstAllowedTab);
    this.getServiceOrderStats();
    this.getCustomerStats();
    this.getAllServiceConnectionCount();
    this.getAllServiceRequestTrackerCount();
  }

  changeTab(page: number) {
    this.currentTab = page;
    this.router.navigate(['/new-service', this.currentTab]);
  }

  isTabAllowed(tab: number): boolean {
    switch (tab) {
      case 1: return this.permissionsService.isNewServiceViewAllowed;
      case 2: return this.permissionsService.isSiteVerificationViewAllowed;
      case 3: return this.permissionsService.isServiceRequestAuthViewAllowed;
      case 4: return this.permissionsService.isOnboardedCustomersViewAllowed;
      case 5: return this.permissionsService.isServiceRequestTrackerViewAllowed;
      default: return false;
    }
  }

  getFirstAllowedTab(): number | null {
    return [1, 2, 3, 4, 5].find(tab => this.isTabAllowed(tab)) ?? null;
  }

  private getServiceOrderStats() {
    this.siteVerificationService.getStats().subscribe({
      next: (response: any) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.serviceOrderStats = data.data;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getCustomerStats() {
    var obj = this.getKycFilterObject();
    this.customerStats = new NewServiceStats();
    this.getOnboardedStats(obj);
  }

  getKycFilterObject() {
    let obj = {
      sortBy: SortByOptions.NEWEST,
      search: '',
      dateFrom: null,
      dateTo: null,
      kycStatus: null,
      tag: null,
      selectedAreas: null,
      selectedRegions:
        null,
      selectedIds: []
    };
    return obj;
  }

  private getOnboardedStats(obj: any) {
    var filter = {
      filter: obj,
      Option: CustomerStatsOptions.Onboarded,
    };
    this.customerService.getOnboardedCustomersStats(filter).subscribe({
      next: (response: any) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.customerStats.newConnection = data.data.newConnection;
          this.customerStats.onboardedCustomers = data.data.onboardedCustomers;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAllServiceConnectionCount() {
    let obj = {
      pageInfo: {
        page: 1,
        pageSize: 10,
        count: this.serviceConnectionChargesCount,
      },
      filterParams: this.getKycFilterObject(),
      utilityId: this.utilityId,
    };

    this.getCount(obj);
  }

  private getAllServiceRequestTrackerCount() {
    let obj = {
      pageInfo: {
        page: 1,
        pageSize: 10,
        count: this.serviceRequestTrackerCount,
      },
      filterParams: this.getKycFilterObject(),
      utilityId: this.utilityId,
    };

    this.kycAccountService.getAllServiceRequestTrackerCount(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.serviceRequestTrackerCount = responseData?.data ?? this.serviceRequestTrackerCount;
        } else if (response?.status == 204) {
          this.toastr.warning('No content');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  private getCount(obj: any) {
    this.kycAccountService.getAllServiceConnectionCount(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.serviceConnectionChargesCount = responseData?.data ?? this.serviceConnectionChargesCount;
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else if (response?.status == 204) {
          this.toastr.warning('No content');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  
}
